import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const HelmetMeta = () => {
  const location = useLocation();

  const getMetaData = (path) => {
    switch (path) {
      case "/":
        return {
          title:
            "StratCap Digital Infrastructure REIT - Investing in Data Centers & Cell Towers",
          description: `StratCap Digital Infrastructure REIT, Inc. is a public, non-traded REIT focused on investing in
mission-critical digital infrastructure assets like data centers, cell towers, and fiber networks. Explore
investment opportunities in assets that form the backbone of the digital economy.`,
        };
      case "/investments":
        return {
          title:
            "StratCap Digital Infrastructure REIT Investment Details - Data Centers, Cell Towers & Fiber",
          description: `Explore StratCap Digital Infrastructure REIT’s investment portfolio, featuring key metrics on data
centers, cell towers, and fiber networks. Discover how our assets and tenants help power digital
transformation.`,
        };
      case "/performance":
        return {
          title:
            "StratCap Digital Infrastructure REIT Performance - Share Class Returns & Insights",
          description: `Review the investment performance of StratCap Digital Infrastructure REIT, including historical returns,
share class performance, and key financial metrics. Gain insights into our digital infrastructure
investment strategy.`,
        };
      case "/offeringdetails":
        return {
          title:
            "StratCap Digital Infrastructure REIT - Investment Terms & Offering Details",
          description: `Discover key investment details for StratCap Digital Infrastructure REIT, including investor suitability,
minimum investment, annual distribution rate, liquidity, fee structure, tax reporting, and NAV
determination frequency.`,
        };
      case "/team":
        return {
          title:
            "StratCap Digital Infrastructure REIT | Leadership, Investment Team & Governance",
          description: `Meet the leadership behind StratCap Digital Infrastructure REIT. Learn about our highly experienced
investment management team and board of directors overseeing our digital infrastructure investments
and processes.`,
        };
      case "/literature":
        return {
          title:
            "StratCap Digital Infrastructure REIT | Investor Materials & Insights",
          description: `Access key literature and materials on StratCap Digital Infrastructure REIT to learn more about this
exciting digital infrastructure investment opportunity.`,
        };
      case "/investorrelations":
        return {
          title:
            "StratCap Digital Infrastructure REIT | Investor Relations, SEC Filings & Communications",
          description: `Stay informed with the latest investor updates from StratCap Digital Infrastructure REIT. Access press
releases, SEC filings, and key investor communications to stay up to date on our activities, performance
and strategy.`,
        };
      default:
        return {
          title: "StratCap Digital Infrastructure REIT",
          description: `StratCap Digital Infrastructure REIT, Inc. is a public, non-traded REIT focused on investing in
mission-critical digital infrastructure assets like data centers, cell towers, and fiber networks. Explore
investment opportunities in assets that form the backbone of the digital economy.`,
        };
    }
  };

  const { title, description } = getMetaData(location.pathname);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default HelmetMeta;
